import 'css-chunk:src/app/containers/Home/CommunitiesView/CommunityListView.scss';export default {
  "CommunityListView": "_CommunityListView_1u6ov_2",
  "header": "_header_1u6ov_2",
  "createButton": "_createButton_1u6ov_7",
  "table": "_table_1u6ov_10",
  "idCell": "_idCell_1u6ov_10",
  "clientCell": "_clientCell_1u6ov_14",
  "clientTag": "_clientTag_1u6ov_19"
};